"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const weekDays = ['MO', 'DI', 'MI', 'DO', 'FR', 'SA', 'SO'];
const dayMs = 1000 * 60 * 60 * 24;

const daysInMonth = (month, year) => {
  return new Date(year, month, 0).getDate();
};

const weekDay = dateStr => {
  const date = new Date(dateStr);
  return date.getUTCDay() || 7;
};

const weekNr = dateStr => {
  const date = new Date(dateStr);
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const dayNum = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  const nr = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  return String(nr).padStart(2, '0');
};

const fillWeekWithPrevMonthDays = dateStr => {
  const cnt = weekDay(dateStr) - 1;
  const firstDate = Number(new Date(dateStr));
  const res = [];

  for (let i = 0; i < cnt; i++) {
    const d = new Date(firstDate - dayMs * (i + 1)).toISOString().split('T')[0];
    res.unshift(d);
  }

  return res;
};

const fillWeekWithNextMonthDays = week => {
  const lastDate = Number(new Date(week[week.length - 1]));
  const cnt = 7 - week.length;
  const nextMonthDays = [];

  for (let i = 0; i < cnt; i++) {
    const d = new Date(lastDate + dayMs * (i + 1)).toISOString().split('T')[0];
    nextMonthDays.push(d);
  }

  return [...week, ...nextMonthDays];
};

const dateStr = (day, month, year) => {
  const dayStr = String(day).padStart(2, '0');
  const monthStr = String(month).padStart(2, '0');
  return `${year}-${monthStr}-${dayStr}`;
};

const genWeeks = (month, year) => {
  const daysCnt = daysInMonth(month, year);
  const weeks = [];
  let week = [];

  for (let i = 0; i < daysCnt; i++) {
    const d = dateStr(i + 1, month, year);

    if (i === 0) {
      week = fillWeekWithPrevMonthDays(d);
    }

    week.push(d);

    if (week.length === 7 || i === daysCnt - 1) {
      if (i === daysCnt - 1) {
        week = fillWeekWithNextMonthDays(week);
      }

      weeks.push(week);
      week = [];
    }
  }

  return weeks;
};

const Header = _styledComponents.default.div.withConfig({
  displayName: "MonthView__Header",
  componentId: "sc-1d3ygnh-0"
})(["border-bottom:1px solid #eee;background:#fafafa;font-weight:400;ul{display:flex;height:32px;}li{display:flex;justify-content:center;align-items:center;flex:1;}"]);

const WeekNr = _styledComponents.default.div.withConfig({
  displayName: "MonthView__WeekNr",
  componentId: "sc-1d3ygnh-1"
})(["display:flex;justify-content:center;align-items:center;min-width:calc(100% / 8);min-height:32px;border-right:1px solid #eee;"]);

const Weeks = _styledComponents.default.div.withConfig({
  displayName: "MonthView__Weeks",
  componentId: "sc-1d3ygnh-2"
})(["display:flex;flex-direction:column;flex:1;> ul{flex:1;display:flex;flex-direction:column;> li{display:flex;flex:1;}}"]);

const getDay = date => {
  return date.split('-')[2];
};

const isCurrMonth = (date, month) => {
  const res = parseInt(date.split('-')[1], 10) === month;
  return res;
};

const Week = _styledComponents.default.div.withConfig({
  displayName: "MonthView__Week",
  componentId: "sc-1d3ygnh-3"
})(["flex:1;height:100%;ul{display:flex;flex:1;height:100%;}"]);

const Day = _styledComponents.default.li.withConfig({
  displayName: "MonthView__Day",
  componentId: "sc-1d3ygnh-4"
})(["display:flex;justify-content:center;align-items:center;flex:1;font-size:16px;text-align:center;cursor:pointer;min-height:32px;border:1px solid transparent;opacity:", ";", ";", " ", " ", ""], p => p.currMonth ? 1 : 0.5, p => p.transition, p => p.today && (0, _styledComponents.css)(["font-weight:700;"]), p => p.selected && (0, _styledComponents.css)(["border-color:", ";color:", ";"], p.theme.colors.main, p.theme.colors.main), p => !p.selected && (0, _styledComponents.css)(["&:hover{background:#eee;}"]));

class MonthView extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {});

    _defineProperty(this, "handleSelect", date => e => {
      const {
        onSelect
      } = this.props;
      onSelect(date);
    });

    _defineProperty(this, "isToday", date => {
      const nowDate = new Date().toISOString().split('T')[0];
      return date === nowDate;
    });

    _defineProperty(this, "isSelected", (date, dateToSelect) => {
      return dateToSelect === date;
    });

    _defineProperty(this, "renderWeek", week => {
      const {
        month,
        select
      } = this.props;
      return /*#__PURE__*/_react.default.createElement(Week, null, /*#__PURE__*/_react.default.createElement("ul", null, week.map((date, idx) => /*#__PURE__*/_react.default.createElement(Day, {
        key: idx,
        currMonth: isCurrMonth(date, month),
        today: this.isToday(date),
        selected: this.isSelected(date, select),
        onClick: this.handleSelect(date)
      }, getDay(date)))));
    });

    _defineProperty(this, "renderWeeks", () => {
      const {
        month,
        year
      } = this.props;
      const weeks = genWeeks(month, year);
      return /*#__PURE__*/_react.default.createElement(Weeks, null, /*#__PURE__*/_react.default.createElement("ul", null, weeks.map((week, idx) => {
        return /*#__PURE__*/_react.default.createElement("li", {
          key: idx
        }, /*#__PURE__*/_react.default.createElement(WeekNr, null, weekNr(week[0])), this.renderWeek(week));
      })));
    });
  }

  render() {
    const {
      className
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: className
    }, /*#__PURE__*/_react.default.createElement(Header, null, /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null), weekDays.map(item => /*#__PURE__*/_react.default.createElement("li", {
      key: item
    }, item)))), this.renderWeeks());
  }

}

var _default = (0, _styledComponents.default)(MonthView).withConfig({
  displayName: "MonthView",
  componentId: "sc-1d3ygnh-5"
})(["display:flex;flex-direction:column;width:100%;height:240px;border:1px solid #eee;"]);

exports.default = _default;